import router from './router'
import store from './store'
import { getQueryStr } from '@/utils/index';//url参数
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/404'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
    // start progress bar
    NProgress.start()

    // in the free login whitelist, go directly
    if (whiteList.indexOf(to.path) !== -1) {
        next()
    } else {

        const orgId = getQueryStr('orgId')
        const orgName = store.getters.orgName

        if (orgId) {
            // 如果store没有orgId
            if (!store.getters.orgId) { store.commit('app/SET_ORGID', orgId) }

            if (orgName) {
                next()
            } else {
                // 没有机构信息
                try {
                    // get user info
                    await store.dispatch('app/getInfo')
                    next()
                } catch (error) {
                    Message.error('没有机构信息')
                    next({ path: '/404' })
                    NProgress.done()
                }
            }

        } else {
            // url没有orgId
            Message.error('没有机构id')
            next({ path: '/404' })
            NProgress.done()
        }
    }

})

router.afterEach(() => {
    // finish progress bar
    NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js